import { useAuthStore } from "@/stores";
import axios from "axios";
import { setup } from "axios-cache-adapter";

export function http() {
  const authStore = useAuthStore();
  return axios.create({
    baseURL: "/api",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `Bearer ${authStore.$state.token}`,
    },
  });
}
let cachedInstance; // keep one instance across calls

export function httpWithCache(maxAge = 1000 * 60 * 3) {
  if (cachedInstance) return cachedInstance;

  const authStore = useAuthStore();

  cachedInstance = setup({
    baseURL: "/api",
    cache: {
      maxAge,
      exclude: { query: false },
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `Bearer ${authStore.$state.token}`,
    },
  });

  return cachedInstance;
}
